import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "./auth";

/**
 * Renders children only when a login token exists; otherwise redirects to /login
 * and preserves the attempted location for post-login navigation.
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
